import { Col, Row } from "antd";
import DoctorData from "./doctorData";
import DoctorAppointments from "./doctorAppointments";
import DoctorPatients from "./doctorPatients";

import classes from "./doctorDashboard.module.css";

const DoctorDashboard = () => {
  return (
    <>
      <DoctorData/>
      <Row
        gutter={[
          {
            xs: 16, sm: 16, md: 16, lg: 40
          },
          {
            xs: 16, sm: 16, md: 16, lg: 40
          },
        ]}
        className={classes.container}
      >
        <Col xs={{ flex: "100%" }} md={12} className={classes.col}>
          <DoctorAppointments/>
        </Col>
        <Col xs={24} md={12} className={classes.col}>
          <DoctorPatients/>
        </Col>
      </Row>
    </>
  );
};

export default DoctorDashboard;
